import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { AppService } from 'src/_services/app.service';
import { AuthenticationService } from 'src/_services/authentication.service';

@Component({
  selector: 'app-tommy-manual',
  templateUrl: './tommy-manual.component.html',
  styleUrls: ['./tommy-manual.component.scss']
})
export class TommyManualComponent implements OnInit {
  displayedColumns: string[] = [
    "OpenDate",
    "EventId",
    "EventName",
    "SportId",
    "CompetitionId",
    "Status",
    "Action",
  ];
  sportsList = [];
  tommyData = new MatTableDataSource();

  constructor(
    private appService: AppService,
    private router: Router,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.getTommyManualData();
    this.getSportsByProvider("Tommy");

  }

  getTommyManualData() {
    try {
      this.appService.getTommyManualData().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.tommyData = new MatTableDataSource<any>(res.manualData);
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  createNewEvent = () => {
    let dialogRef = this.dialog.open(CreateTommyEvent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: { title: "Add New Event",
              add:true,
              sports:this.sportsList
            },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getTommyManualData();
      }
    });
  };

   getSportsByProvider(providerId) {
    try {
      this.appService.getSportData(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sportsList = res.sports;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  getSportNameById(sportId: string): string {
    const sport = this.sportsList.find((s) => s.SportId === sportId);
    return sport ? sport.SportName : '';
  }

  updateNewEvent = (data) => {
    let dialogRef = this.dialog.open(CreateTommyEvent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: { 
        title: "Edit Event",
        add:false,
        sports:this.sportsList,
        sportId: data.sportId,
        eventId: data.eventId,
        eventName: data.eventName,
        eventStatus: data.eventStatus,
        openDate: data.openDate,
        competitionId: data.competitionId
            },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getTommyManualData();
      }
    });
  };

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm A");
  }

}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./create-tommy-event.html",
  styleUrls: ["./create-tommy-event.scss"],
})
export class CreateTommyEvent {
  tommyManual : FormGroup
  openDate;
  selected = new FormControl();
  statuses = ["IN_PLAY","UPCOMING","OPEN","CLOSED","SUSPENDED"]
  constructor(
    private appService: AppService,
    public dialogRef: MatDialogRef<CreateTommyEvent>,
    @Inject(MAT_DIALOG_DATA) public Data: any
  ) {}

  data= this.Data
  check = !this.data.add

  ngOnInit() {
    if (this.data.openDate) {
      let date = moment(this.data.openDate);
      var stillUtc = moment.utc(date).toDate();
      this.openDate = moment(stillUtc).unix(); // store epoch time in openDate
      this.selected.setValue({ startDate: moment(stillUtc), endDate: null }); // update FormControl
    } else {
      this.openDate = moment().startOf('minute').unix(); // store current epoch time without seconds in openDate
      this.selected.setValue({ startDate: moment().startOf('minute'), endDate: null }); // update FormControl
    }

    this.tommyManual = new FormGroup({
      sportId: new FormControl (this.data.sportId, Validators.required),
      eventId: new FormControl (this.data.eventId, Validators.required),
      eventName: new FormControl (this.data.eventName, Validators.required),
      eventStatus: new FormControl (this.data.eventStatus, Validators.required),
      competitionId: new FormControl (this.data.competitionId, Validators.required),
    });

  }

  onDateChangeHandler(event: any): void {
    if (event.startDate) {
      this.openDate = moment(event.startDate).unix();
    } else {
      this.openDate = 0;
    }
  }

  confirm() {
    const payload = {
      providerId: "Tommy",
      sportId: this.tommyManual.value.sportId,
      eventId: this.tommyManual.value.eventId,
      eventName: this.tommyManual.value.eventName,
      eventStatus: this.tommyManual.value.eventStatus,
      competitionId: this.tommyManual.value.competitionId,
      opendate: this.openDate * 1000,
    }
    if (this.data.add) {
    try {
      this.appService.createTommyManualData(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
          this.dialogRef.close(true);
        } else {
          this.appService.openErrorBar(res.errorDescription);
          this.dialogRef.close();
        }
      });
    } catch (err) {}
  } else {
    try {
      this.appService.updateTommyManualData(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
          this.dialogRef.close(true);
        } else {
          this.appService.openErrorBar(res.errorDescription);
          this.dialogRef.close();
        }
      });
    } catch (err) {}
  }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
